<nav
    id="application-navigation"
    class="sidebar-inner"
    tabindex="-1"
    qpxClickOutside
    [ignoredSelectors]="clickOutsideIgnoredSelectors"
    (clickOutside)="onClickedOutside()"
    (keydown.escape)="onEscape($event)"
>
    <mat-nav-list
        class="collapsible-list main-navigation"
        [class.expanded]="isEffectiveExpanded()"
        aria-label="Main navigation"
    >
        @if (hasPortalContent()) {
            <ng-container
                *ngTemplateOutlet="
                    portalContent()!.template;
                    context: portalContent()!.context
                "
            />
        } @else {
            <ng-container
                *ngTemplateOutlet="
                    navItemsTemplate;
                    context: getNavItemsTemplateContext()
                "
            />
        }
    </mat-nav-list>

    <ng-template
        #navItemsTemplate
        qpxNavListTpl
        let-items
        let-isEffectiveExpanded="isEffectiveExpanded"
        let-onNavItemClick="onNavItemClick"
    >
        @for (item of resolvedNavItemsGeneral(); track item.key) {
            @switch (item.kind) {
                @case ('header') {
                    <h3 matSubheader class="navigation">
                        {{ item.label }}
                    </h3>
                }
                @case ('button') {
                    <button
                        mat-list-item
                        qpx
                        context="navigation"
                        [interactive]="true"
                        [class]="item.className"
                        [matBadge]="item.badge"
                        [matBadgeDescription]="item.badgeDescription ?? ''"
                        [attr.aria-controls]="item.ariaControls ?? null"
                        [attr.aria-expanded]="item.ariaExpanded ?? null"
                        [attr.aria-haspopup]="item.ariaHasPopup ?? null"
                        [attr.aria-label]="item.ariaLabel ?? null"
                        (click)="onNavItemClick(item)"
                    >
                        <ng-icon matListItemIcon qpx [name]="item.icon" />
                        <span matListItemTitle>{{ item.label }}</span>
                    </button>
                }
                @case ('link') {
                    <a
                        mat-list-item
                        qpx
                        context="navigation"
                        [interactive]="true"
                        [class]="item.className"
                        [routerLink]="item.route"
                        routerLinkActive
                        #rla="routerLinkActive"
                        [activated]="rla.isActive"
                        [routerLinkActiveOptions]="{ exact: !!item.exact }"
                        (click)="onNavItemClick(item)"
                    >
                        <ng-icon matListItemIcon qpx [name]="item.icon" />
                        <span matListItemTitle>{{ item.label }}</span>
                    </a>
                }
            }
        }

        <h3 matSubheader class="navigation">Organisation</h3>

        <qpx-nav-hero-item
            [identifier]="org().id"
            [line1]="org().name"
            fallbackIcon="lucideBriefcaseBusiness"
            context="navigation"
        />

        @for (item of resolvedNavItemsOrg(); track item.key) {
            @switch (item.kind) {
                @case ('header') {
                    <h3 matSubheader class="navigation">
                        {{ item.label }}
                    </h3>
                }
                @case ('link') {
                    <a
                        mat-list-item
                        qpx
                        context="navigation"
                        [interactive]="true"
                        [routerLink]="item.route"
                        routerLinkActive
                        #rla="routerLinkActive"
                        [activated]="rla.isActive"
                        (click)="onNavItemClick(item)"
                    >
                        <ng-icon matListItemIcon qpx [name]="item.icon" />
                        <span matListItemTitle>{{ item.label }}</span>
                    </a>
                }
            }
        }
    </ng-template>

    <mat-nav-list
        class="collapsible-list user-navigation"
        [class.expanded]="isEffectiveExpanded()"
        aria-label="User navigation"
    >
        @if (inAppHelpSupportAvailable) {
            <button
                mat-list-item
                qpx
                context="navigation"
                [interactive]="true"
                (click)="requestWhatsNew()"
                [attr.aria-label]="
                    hasUnreadReleaseNotes()
                        ? 'What\'s new, unread update'
                        : 'What\'s new'
                "
            >
                <ng-icon matListItemIcon qpx name="lucideMegaphone" />
                <span matListItemTitle>What's new</span>
                @if (hasUnreadReleaseNotes()) {
                    <span
                        matListItemMeta
                        class="unread-indicator block size-2 rounded-full bg-primary-decorative"
                        role="img"
                        aria-label="Unread release notes"
                    ></span>
                }
            </button>
        }

        @if (inAppHelpSupportAvailable) {
            <a
                mat-list-item
                qpx
                context="navigation"
                [interactive]="true"
                [href]="contactUsHref"
                (click)="closeSidemenu()"
            >
                <ng-icon matListItemIcon qpx name="lucideMail" />
                <span matListItemTitle>Contact us</span>
            </a>
        }

        <a
            mat-list-item
            qpx
            context="navigation"
            [interactive]="true"
            routerLink="/notifications"
            routerLinkActive="active"
            (click)="closeSidemenu()"
        >
            <ng-icon matListItemIcon qpx name="lucideBell" />
            <span matListItemTitle>Notification settings</span>
        </a>

        <div class="user-divider" aria-hidden="true"></div>

        <qpx-nav-hero-item
            [identifier]="org().id"
            [initials]="userInitials()"
            [line1]="me().displayName"
            fallbackIcon="lucideUser"
            context="navigation"
        >
            <button
                #actions
                qpxButton
                matIconButton
                (click)="signout()"
                aria-label="Sign out"
                qpxTooltip="Sign out"
                matTooltipPosition="right"
                class="signout text-navigation!"
            >
                <ng-icon qpx name="lucideLogOut" />
            </button>
        </qpx-nav-hero-item>
    </mat-nav-list>
</nav>
